<template>
  <el-dialog
    v-model="isModalVisible"
    align-center
    :width="dialogWidth"
    :show-close="false"
    :lock-scroll="true"
    class="!overflow-visible !rounded-[24px] !bg-transparent !p-0 !shadow-none [--el-dialog-bg-color:transparent] [--el-dialog-box-shadow:none] [--el-dialog-padding-primary:0] [&_.el-dialog__body]:!p-0 [&_.el-dialog__header]:!hidden [&_.el-dialog__header]:!p-0"
    @close="handleClose"
  >
    <section
      class="relative box-border flex h-[487px] w-[762px] max-h-[78vh] flex-col overflow-hidden rounded-[24px] bg-[linear-gradient(180deg,#fff3dc_0%,#fff9f0_18%,#ffffff_100%)] px-[24px] pb-[24px] pt-[20px] font-['AlibabaPuHuiTi-Regular','GwbFont','PingFang_SC',sans-serif] max-md:h-[min(487px,86vh)] max-md:w-full max-md:max-h-[86vh] max-md:rounded-[20px] max-md:px-[16px] max-md:pb-[20px] max-md:pt-[18px]"
      aria-label="可用优惠券"
    >
      <button
        class="absolute right-[10px] top-[10px] z-[2] h-[32px] w-[32px] cursor-pointer border-0 bg-transparent p-0"
        type="button"
        aria-label="关闭可用优惠券"
        @click="close"
      >
        <span class="m-[2.67px] flex h-[26.67px] w-[26.67px] items-center justify-center rounded-[13.34px] bg-white/70">
          <img class="block h-[20px] w-[20px]" :src="myCouponCloseIcon" alt="" />
        </span>
      </button>

      <header class="px-[4px] max-md:pl-0 max-md:pr-[16px]">
        <h2 class="m-0 font-['AlibabaPuHuiTi_2_65_Medium','AlibabaPuHuiTi-Medium','AlibabaPuHuiTi-Regular','GwbFont','PingFang_SC',sans-serif] text-[20px] font-medium leading-[28px] text-[#851a00]">可用优惠券</h2>
        <p class="m-0 mt-[4px] font-['AlibabaPuHuiTi-Regular','GwbFont','PingFang_SC',sans-serif] text-[13px] font-normal leading-[18px] text-[rgba(133,26,0,0.66)]">当前充值项可使用的优惠券</p>
      </header>

      <main
        class="mt-[16px]"
        :class="displayCoupons.length
          ? 'grid min-h-0 flex-1 auto-rows-[86px] grid-cols-2 content-start gap-x-[20px] gap-y-[12px] overflow-y-auto pb-[8px] [scrollbar-width:none] max-md:grid-cols-1 max-md:gap-[10px] [&::-webkit-scrollbar]:hidden'
          : 'flex min-h-0 flex-1 items-center justify-center overflow-hidden'"
      >
        <template v-if="displayCoupons.length">
          <article
            v-for="coupon in displayCoupons"
            :key="coupon.id"
            class="relative box-border flex h-[86px] min-w-0 items-center gap-[16px] overflow-hidden rounded-[10px] border px-[16px]"
            :class="getCouponCardClass(coupon)"
            :aria-disabled="!isCouponSelectable(coupon)"
            :title="getUnavailableReasonText(coupon)"
            @click="selectCoupon(coupon)"
          >
            <!-- <span
              v-if="coupon.recommended"
              class="absolute right-0 top-0 h-[20px] rounded-bl-[8px] bg-[#ff6b3f] px-[8px] font-['AlibabaPuHuiTi_2_65_Medium','AlibabaPuHuiTi-Medium','AlibabaPuHuiTi-Regular','GwbFont','PingFang_SC',sans-serif] text-[11px] font-medium leading-[20px] text-white"
            >
              推荐
            </span> -->

            <div class="flex w-[70px] shrink-0 flex-col items-center gap-[8px]">
              <div
                class="flex h-[28px] items-baseline justify-center whitespace-nowrap font-['AlibabaPuHuiTi_2_65_Medium','AlibabaPuHuiTi-Medium','AlibabaPuHuiTi-Regular','GwbFont','PingFang_SC',sans-serif] font-medium leading-[28px]"
                :class="getCouponAmountClass(coupon)"
              >
                <template v-if="coupon.type === 'discount'">
                  <span class="font-['AlibabaPuHuiTi_2_65_Medium','AlibabaPuHuiTi-Medium','AlibabaPuHuiTi-Regular','GwbFont','PingFang_SC',sans-serif] text-[30px] font-semibold leading-[28px]">{{ coupon.displayValue }}</span>
                  <em class="ml-[2px] text-[18px] font-medium not-italic leading-[24px] font-['AlibabaPuHuiTi_2_65_Medium','AlibabaPuHuiTi-Medium','AlibabaPuHuiTi-Regular','GwbFont','PingFang_SC',sans-serif]">折</em>
                </template>
                <template v-else>
                  <em class="mr-[4px] text-[20px] font-medium not-italic leading-[28px] font-['AlibabaPuHuiTi_2_65_Medium','AlibabaPuHuiTi-Medium','AlibabaPuHuiTi-Regular','GwbFont','PingFang_SC',sans-serif]">¥</em>
                  <span class="font-['AlibabaPuHuiTi_2_65_Medium','AlibabaPuHuiTi-Medium','AlibabaPuHuiTi-Regular','GwbFont','PingFang_SC',sans-serif] text-[30px] font-semibold leading-[28px]">{{ coupon.displayValue }}</span>
                </template>
              </div>
              <div
                class="box-border flex h-[24px] min-w-[61px] items-center justify-center whitespace-nowrap rounded-[21px] border px-[10px] text-center font-['AlibabaPuHuiTi-Regular','GwbFont','PingFang_SC',sans-serif] text-[12px] font-normal leading-[17px]"
                :class="getCouponThresholdClass(coupon)"
              >
                {{ coupon.thresholdText }}
              </div>
            </div>

            <div
              class="h-[60px] w-0 shrink-0 border-l border-dashed"
              :class="isCouponSelectable(coupon) ? 'border-[rgba(255,107,63,0.6)]' : 'border-[rgba(29,31,38,0.5)]'"
              aria-hidden="true"
            ></div>

            <div class="flex min-w-0 flex-[1_1_auto] flex-col gap-[6px]" :class="getCouponContentClass(coupon)">
              <div class="flex min-w-0 flex-col gap-[4px]">
                <div class="max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-['AlibabaPuHuiTi_2_65_Medium','AlibabaPuHuiTi-Medium','AlibabaPuHuiTi-Regular','GwbFont','PingFang_SC',sans-serif] text-[14px] font-medium leading-[20px]">{{ coupon.name }}</div>
                <div
                  class="max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-['AlibabaPuHuiTi-Regular','GwbFont','PingFang_SC',sans-serif] text-[12px] font-normal leading-[17px]"
                  :class="isCouponSelectable(coupon) ? 'text-[rgba(133,26,0,0.7)]' : 'text-[rgba(29,31,38,0.6)]'"
                >
                  {{ coupon.scopeText }}
                </div>
              </div>
              <div
                class="flex min-w-0 items-center gap-[4px] whitespace-nowrap font-['AlibabaPuHuiTi-Regular','GwbFont','PingFang_SC',sans-serif] text-[12px] font-normal leading-[17px]"
                :class="isCouponSelectable(coupon) ? 'text-[#ff6b3f]' : 'text-[rgba(29,31,38,0.6)]'"
              >
                <img class="h-[16px] w-[16px] shrink-0" :class="isCouponSelectable(coupon) ? '' : 'grayscale opacity-60'" :src="myCouponClockIcon" alt="" />
                <span class="min-w-0 whitespace-nowrap text-[12px]">{{ coupon.validText }}</span>
              </div>
            </div>

            <img
              v-if="isCouponSelectable(coupon)"
              class="ml-auto h-[20px] w-[20px] shrink-0"
              :src="selectedCouponId === coupon.id ? couponRadioChecked : couponRadioUnchecked"
              alt=""
            />
            <span
              v-else
              class="ml-auto flex h-[28px] shrink-0 items-center justify-center rounded-[10px] bg-white/80 px-[12px] font-['AlibabaPuHuiTi_2_65_Medium','AlibabaPuHuiTi-Medium','AlibabaPuHuiTi-Regular','GwbFont','PingFang_SC',sans-serif] text-[12px] font-medium leading-[17px] text-[rgba(29,31,38,0.6)]"
            >
              不可用
            </span>
          </article>
        </template>

        <div v-else-if="isLoading" class="flex flex-col items-center gap-[10px] text-[rgba(29,31,38,0.5)]">
          <span class="h-[24px] w-[24px] animate-spin rounded-full border-[2px] border-[rgba(255,107,63,0.18)] border-t-[#ff6b3f]"></span>
          <p class="m-0 font-['AlibabaPuHuiTi-Regular','GwbFont','PingFang_SC',sans-serif] text-[14px] font-normal leading-[20px]">加载中...</p>
        </div>

        <div v-else class="flex translate-y-[-11px] flex-col items-center gap-[2px]">
          <img class="h-[90px] w-[90px] object-contain" :src="myCouponEmptyState" alt="" />
          <p class="m-0 text-center font-['AlibabaPuHuiTi-Regular','GwbFont','PingFang_SC',sans-serif] text-[14px] font-normal leading-[20px] text-[rgba(29,31,38,0.6)]">当前充值项暂无可用优惠券</p>
        </div>
      </main>

      <footer class="mt-[16px] flex h-[40px] items-center justify-end gap-[10px]">
        <button
          class="h-[40px] w-[132px] rounded-[8px] border-0 bg-[#f4f4f4] font-['AlibabaPuHuiTi-Regular','GwbFont','PingFang_SC',sans-serif] text-[16px] font-normal leading-[40px] text-[#70706f]"
          type="button"
          @click="close"
        >
          取消
        </button>
        <button
          class="h-[40px] w-[132px] rounded-[8px] border-0 bg-[linear-gradient(90deg,#ff3e20_0%,#ff6d29_100%)] font-['AlibabaPuHuiTi_2_65_Medium','AlibabaPuHuiTi-Medium','AlibabaPuHuiTi-Regular','GwbFont','PingFang_SC',sans-serif] text-[16px] font-medium leading-[40px] text-[#fff3dc]"
          type="button"
          @click="confirmSelection"
        >
          确认
        </button>
      </footer>
    </section>
  </el-dialog>
</template>

<script setup>
import { computed, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { getAvailableCoupon } from '@/api/coupon'
import myCouponCloseIcon from '@/assets/images/myCoupon/my-coupon-close.svg'
import myCouponClockIcon from '@/assets/images/availableCoupon/coupon-vip.svg'
import myCouponEmptyState from '@/assets/images/myCoupon/my-coupon-empty-state.png'
import couponRadioUnchecked from '@/assets/images/availableCoupon/coupon-radio-unchecked.png'
import couponRadioChecked from '@/assets/images/availableCoupon/coupon-radio-checked.png'

defineOptions({ name: 'AvailableCouponModal' })

const emit = defineEmits(['close', 'select'])

const isModalVisible = ref(false)
const isLoading = ref(false)
const catalogCode = ref('')
const selectedCouponId = ref('')
const coupons = ref([])
const latestRequestKey = ref(0)

const getDialogWidth = () => {
  if (typeof window !== 'undefined' && window.innerWidth <= 768) return 'calc(100vw - 24px)'
  return '762px'
}

const dialogWidth = ref(getDialogWidth())

const hasCouponUserId = (coupon) => {
  const userCouponId = coupon?.userCouponId
  return userCouponId !== undefined && userCouponId !== null && userCouponId !== ''
}

const isCouponSelectable = (coupon) => coupon?.canUse !== false && hasCouponUserId(coupon)

const sortCouponsByAvailability = (list = []) => {
  return [...list].sort((prev, next) => Number(!isCouponSelectable(prev)) - Number(!isCouponSelectable(next)))
}

const unavailableReasonTextMap = {
  NOT_EFFECTIVE: '未生效',
  EXPIRED: '已过期',
  RULE_SNAPSHOT_MISSING: '快照缺失',
  CATALOG_NOT_SUPPORTED: '充值项不适用',
  THRESHOLD_NOT_MET: '未达使用门槛',
  MINIMUM_PAYMENT_LIMIT: '最低支付金额限制'
}

const getUnavailableReasonText = (coupon) => {
  if (isCouponSelectable(coupon)) return ''
  return unavailableReasonTextMap[coupon?.unavailableReason] || coupon?.unavailableReason || '不可用'
}

const getCouponCardClass = (coupon) => {
  if (!isCouponSelectable(coupon)) {
    return 'cursor-not-allowed border-white/80 bg-[linear-gradient(90deg,#f9f9f9_0%,#f3f3f3_100%)]'
  }
  return 'cursor-pointer border-[rgba(255,107,63,0.18)] bg-[linear-gradient(90deg,#fffcf7_0%,#fff5e8_100%)]'
}

const getCouponAmountClass = (coupon) => {
  return isCouponSelectable(coupon) ? 'text-[#ff6b3f]' : 'text-[rgba(29,31,38,0.6)]'
}

const getCouponThresholdClass = (coupon) => {
  return isCouponSelectable(coupon)
    ? 'border-[rgba(133,26,0,0.06)] text-[#851a00]'
    : 'border-[rgba(29,31,38,0.06)] text-[rgba(29,31,38,0.6)]'
}

const getCouponContentClass = (coupon) => {
  return isCouponSelectable(coupon) ? 'text-[#851a00]' : 'text-[rgba(29,31,38,0.6)]'
}

const displayCoupons = computed(() => sortCouponsByAvailability(coupons.value))

const selectedCoupon = computed(() => displayCoupons.value.find((coupon) => coupon.id === selectedCouponId.value && isCouponSelectable(coupon)) || null)

const formatAmount = (value) => {
  const number = Number(value ?? 0)
  if (!Number.isFinite(number)) return '0'
  return Number.isInteger(number) ? String(number) : String(Number(number.toFixed(2))).replace(/\.0+$/, '')
}

const formatCouponValue = (value, isRate = false) => {
  const number = Number(value ?? 0)
  if (!Number.isFinite(number)) return '0'

  let normalizedValue = number
  if (isRate && number > 0 && number <= 1) normalizedValue = number * 10
  if (isRate && number > 10 && number <= 100) normalizedValue = number / 10

  return formatAmount(normalizedValue)
}

const getThresholdText = (coupon) => {
  if (coupon.thresholdText) return coupon.thresholdText
  const threshold = Number(coupon.thresholdAmount ?? coupon.threshold ?? coupon.fullAmount ?? 0)
  if (!threshold || coupon.couponType === 'NO_THRESHOLD') return '无门槛'
  return `满${formatAmount(threshold)}减`
}

const normalizeDate = (value) => {
  if (!value) return null
  if (value instanceof Date) return value
  const normalized = String(value).trim().replace(/-/g, '/').replace(/\./g, '/')
  return new Date(normalized)
}

const formatDate = (value, withYear = true) => {
  const date = normalizeDate(value)
  if (!date || Number.isNaN(date.getTime())) return ''
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return withYear ? `${year}.${month}.${day}` : `${month}.${day}`
}

const getValidText = (coupon) => {
  const start = coupon.validStartTime || coupon.validStartAt || coupon.startTime
  const end = coupon.validEndTime || coupon.validEndAt || coupon.endTime
  if (start && end) {
    const startText = formatDate(start)
    const endText = formatDate(end)
    if (startText && endText) return `${startText} - ${endText}`
  }
  if (coupon.validText) return coupon.validText
  return `优惠后 ¥${formatAmount(coupon.payableAmount)}`
}

const normalizeCoupon = (coupon, index) => {
  const discountAmount = Number(coupon.discountAmount ?? coupon.discountValue ?? 0)
  const discountType = coupon.discountType
  const couponType = coupon.couponType
  const hasDiscountRate = coupon.discount !== undefined && coupon.discount !== null && coupon.discount !== ''
  const type = coupon.type === 'discount' || hasDiscountRate || discountType === 'RATE' || couponType === 'DISCOUNT' ? 'discount' : 'amount'
  const rawValue = type === 'discount'
    ? (coupon.discount ?? coupon.discountValue)
    : (coupon.amount ?? coupon.discountValue ?? discountAmount)
  const basePayPrice = Number(coupon.basePayPrice ?? 0)
  const payableAmount = Number(coupon.payableAmount ?? 0)

  return {
    ...coupon,
    id: coupon.userCouponId ?? `available-coupon-${index}`,
    type,
    displayValue: formatCouponValue(rawValue, type === 'discount'),
    thresholdText: getThresholdText(coupon),
    name: coupon.name || coupon.title || '充值优惠券',
    scopeText: coupon.scopeText || coupon.description || '当前充值项可用',
    validText: getValidText(coupon),
    discountAmount,
    basePayPrice,
    payableAmount,
    canUse: coupon.canUse !== false,
    recommended: coupon.recommended === true
  }
}

const updateSelectedCoupon = (preferredId = '') => {
  const preferredCoupon = displayCoupons.value.find((coupon) => String(coupon.id) === String(preferredId) && isCouponSelectable(coupon))
  selectedCouponId.value = preferredCoupon?.id ?? ''
}

const fetchAvailableCoupons = async (preferredId = '') => {
  if (!catalogCode.value) {
    coupons.value = []
    selectedCouponId.value = ''
    return
  }

  const requestKey = latestRequestKey.value + 1
  latestRequestKey.value = requestKey
  isLoading.value = true

  try {
    const res = await getAvailableCoupon({ catalogCode: catalogCode.value })
    if (requestKey !== latestRequestKey.value) return

    if (res.code === 'SUCCESS') {
      const list = Array.isArray(res.data) ? res.data : []
      coupons.value = list.map(normalizeCoupon)
      updateSelectedCoupon(preferredId)
      return
    }

    coupons.value = []
    selectedCouponId.value = ''
    ElMessage.warning({
      message: res.msg || '优惠券获取失败',
      offset: 85
    })
  } catch (error) {
    if (requestKey !== latestRequestKey.value) return
    coupons.value = []
    selectedCouponId.value = ''
    ElMessage.warning({
      message: error?.message || '优惠券获取失败',
      offset: 85
    })
  } finally {
    if (requestKey === latestRequestKey.value) {
      isLoading.value = false
    }
  }
}

const open = ({ catalogCode: nextCatalogCode = '', selectedCouponId: preferredId = '' } = {}) => {
  dialogWidth.value = getDialogWidth()
  catalogCode.value = nextCatalogCode
  coupons.value = []
  selectedCouponId.value = preferredId || ''
  isModalVisible.value = true
  fetchAvailableCoupons(preferredId)
}

const close = () => {
  isModalVisible.value = false
}

const handleClose = () => {
  emit('close')
}

const selectCoupon = (coupon) => {
  if (!isCouponSelectable(coupon)) return
  selectedCouponId.value = selectedCouponId.value === coupon.id ? '' : coupon.id
}

const confirmSelection = () => {
  emit('select', selectedCoupon.value)
  close()
}

defineExpose({
  open,
  close
})
</script>
